import React, { useEffect, useRef, useState } from "react";
import { withAuthenticator } from "@aws-amplify/ui-react";
import { Auth } from "@aws-amplify/auth";
import "@aws-amplify/ui-react/styles.css";
import { Header } from "components/Login/Header";
import { Footer, FooterWithForgotPassword } from "components/Login/Footer";
import {
  Switch,
  Route,
  Redirect,
  useLocation,
  matchPath,
} from "react-router-dom";
import NotificationAlert from "react-notification-alert";
import { NotificationAlertContext } from "contexts/notificationAlertContext";
import { AuthContext } from "contexts/authContext";
import EULA from "views/EULAComponent/EULA";
import { getUser } from "graphql/queries.js";
import { API, graphqlOperation } from "aws-amplify";
import { TourProvider } from "@reactour/tour";
// react-bootstrap components
import { Spinner } from "react-bootstrap";

// core components
import Sidebar from "components/Sidebar/Sidebar.js";
import AdminNavbar from "components/Navbars/AdminNavbar.js";

// dynamically create dashboard routes
import routes from "routes.js";

function Admin({ user }) {
  const location = useLocation();
  const [routesForGroup, setRoutesForGroup] = useState([]);
  const [showLoader, setShowLoader] = useState(false);

  const signInUserSession = user.signInUserSession;
  const userId = signInUserSession.accessToken.payload.sub;
  let groupName = signInUserSession.accessToken.payload["cognito:groups"][0];
  const userClientId = signInUserSession.idToken.payload["custom:clientId"];
  const userClientName = signInUserSession.idToken.payload["custom:clientName"];
  const [currentUser, setCurrentUser] = useState({
    emailId: "",
    userId: "",
    firstName: "",
    lastName: "",
    groupName: groupName,
    clientId: userClientId,
    clientName: userClientName,
    notifyUser: false,
    permissions: [],
  });

  const mapUserGroup = (user_group) => {
    const groupMap = {
      0: "external",
      1: "internal",
      2: "internal_readonly"
    };
    return groupMap[user_group] || null;
  };


  const notificationAlertRef = useRef(null);
  const notify = (type, message = "", autoDismiss = 7) => {
    if (!message) {
      switch (type) {
        case "success":
          message = "Your request has been completed.";
          break;
        case "danger":
          message = "Unable to process your request at this time.";
          break;
        case "info":
          message = "Your request will be processed.";
          break;
      }
    }
    const options = {
      place: "tr",
      message,
      type,
      icon: "nc-icon nc-bell-55",
    };
    if (autoDismiss >= 0) {
      options["autoDismiss"] = autoDismiss;
    }
    notificationAlertRef.current.notificationAlert(options);
  };

  const checkRoute = (routes, groupName, clientId) => {
    const defaultRedirectPathInternal = `/admin/dashboard`;
    const defaultRedirectPathExternal = `/admin/clients/${clientId}`;
    let match;
    for (const route of routes) {
      match = matchPath(location.pathname, {
        path: route.layout + route.path,
        exact: true,
        strict: false,
      });
      if (match) break;
    }
    if (!match) {
      if (groupName === "internal" || groupName === "internal_readonly") {
        return <Redirect to={defaultRedirectPathInternal} />;
      } else if (groupName === "external") {
        return <Redirect to={defaultRedirectPathExternal} />;
      }
    } else if (
      groupName === "external" &&
      match.params.clientId &&
      match.params.clientId !== clientId
    ) {
      return <Redirect to={defaultRedirectPathExternal} />;
    }
  };

  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.collapse) {
        return getRoutes(prop.views);
      }
      if (prop.layout === "/admin") {
        return (
          <Route
            exact
            path={prop.layout + prop.path}
            key={key}
            component={prop.component}
          />
        );
      } else {
        return null;
      }
    });
  };

  const getUserDetails = async () => {
    try {
      setShowLoader(true);
      const response = await API.graphql(graphqlOperation(getUser));
      if (response.data?.getUser?.success) {
        const userDetails = response.data.getUser.body;
        if (userDetails.is_hidden) {
          // User is disabled
          console.error("User is disabled.");
          return;
        }

        groupName = mapUserGroup(userDetails.user_group) ?? groupName;
        
        if (groupName === "internal") setRoutesForGroup(routes["internal"]);
        else if (groupName === "internal_readonly") setRoutesForGroup(routes["internalReadOnly"]);
        else if (
          groupName === "external" &&
          userDetails.permissions.includes("external_user_admin")
        )
          setRoutesForGroup(routes["externalAdmin"]);
        else setRoutesForGroup(routes["external"]);
        setCurrentUser({
          emailId: userDetails.email_id,
          userId: userId,
          firstName: userDetails.first_name,
          lastName: userDetails.last_name,
          groupName: groupName,
          clientId: userDetails.client_id,
          clientName: userDetails.client_name,
          notifyUser: userDetails.notify_user,
          permissions: userDetails.permissions,
        });
      } else {
        console.error(response.data?.getUser?.message);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setShowLoader(false);
    }
  };

  useEffect(() => {
    getUserDetails();
  }, []);

  const signOut = async () => {
    try {
      await Auth.signOut();
      window.location.reload();
    } catch (error) {
      console.error(error);
    }
  };

  if (showLoader) return <Spinner animation="grow" />;

  return (
    <>
      <EULA user={user} signOut={signOut}>
        <TourProvider>
          <NotificationAlertContext.Provider value={notify}>
            <AuthContext.Provider value={currentUser}>
              <a
                href="/ProdStage"
                rel="nofollow"
                style={{ display: "none" }}
                aria-hidden="true"
              >
                honeypot link
              </a>
              <div className="rna-container">
                <NotificationAlert ref={notificationAlertRef} />
              </div>
              {checkRoute(routesForGroup, groupName, userClientId)}
              <div className="wrapper">
                <Sidebar routes={routesForGroup} />
                <div className="main-panel">
                  <AdminNavbar signOut={signOut} routes={routesForGroup} />
                  <div className="content">
                    <Switch>{getRoutes(routesForGroup)}</Switch>
                  </div>

                  {/* <AdminFooter /> */}
                  {/* <div
                    className="close-layer"
                    onClick={() =>
                      document.documentElement.classList.toggle("nav-open")
                    }
                  /> */}
                </div>
              </div>
            </AuthContext.Provider>
          </NotificationAlertContext.Provider>
        </TourProvider>
      </EULA>
    </>
  );
}

export default withAuthenticator(Admin, {
  hideSignUp: true,
  components: {
    SignIn: {
      Header,
      Footer: FooterWithForgotPassword,
    },
    SetupTOTP: {
      Header,
      Footer,
    },
    ConfirmSignIn: {
      Header,
      Footer,
    },
    ResetPassword: {
      Header,
      Footer,
    },
    ConfirmResetPassword: {
      Header,
      Footer,
    },
  },
});
